module.exports = __webpack_public_path__ + "img/page_bg_aiDetection.483ef677.png";